import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { Calendar, CalendarModule } from 'primeng/calendar';
import { TranslocoPipe } from '@jsverse/transloco';


@Component({
  selector: 'app-custom-date-input',
  standalone: true,
  imports: [FormsModule, CalendarModule, CommonModule, TranslocoPipe],
  providers: [DatePipe],
  templateUrl: './custom-date-input.component.html',
  styleUrl: './custom-date-input.component.css'
})
export class CustomDateInputComponent {
  constructor(private datePipe: DatePipe) { }

  @Input() labelText: string = '';
  @Input() inputId: string = 'date-input';
  @Input() placeholder: string = '';
  @Input() errorMessage: string | null = null;
  @Input() isDisabled: boolean = false;
  @Input() showOnlyValueWhenDisabled: boolean = false;
  @Input() boxHeight: string = '';
  @Input() autoMarginTop: string = 'mt-4';
  @Input() dateFormat: string = 'dd/mm/yy';
  @Input() appendTo: string = 'body';

  @Input() dateValue: Date | undefined = undefined;
  @Output() dateValueChange = new EventEmitter<Date | undefined>();

  @ViewChild('calendarRef') calendar!: Calendar;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dateValue'] && changes['dateValue'].currentValue) {
      this.dateValue = changes['dateValue'].currentValue;
      this.dateValue?.setHours(12, 0, 0, 0);
    }
  }

  onDateChange() {
    this.dateValue?.setHours(12, 0, 0, 0);
    this.dateValueChange.emit(this.dateValue);
  }

  openCalendar() {
    if (this.calendar && !this.isDisabled && !this.calendar.overlayVisible) {
      this.calendar.toggle();
    }
  }

  formatDateValue(): string {
    if (!this.dateValue) {
      return '';
    }

    var normalizedFormat = this.dateFormat;
    normalizedFormat = normalizedFormat.replace(/(^|[^M])mm/g, '$1MM');

    return this.datePipe.transform(this.dateValue, normalizedFormat) ?? '';
  }
}
